import navigateToNextOnboardingPageAction from "@actions/navigateToNextOnboardingPageAction"
import onboardingLoader from "@loaders/onboardingLoader"
import { Navigate, Outlet } from "react-router-dom"
import AgePage from "./AgePage"
import AlmostTherePage from "./AlmostTherePage"
import BoldLooksPage from "./BoldLooksPage"
import CompanyPage from "./CompanyPage"
import ComplimentPage from "./ComplimentPage"
import ConfidenceBoostPage from "./ConfidenceBoostPage"
import DoingAmazingPage from "./DoingAmazingPage"
import ExperimentingLookPage from "./ExperimentingLookPage"
import FirstImpressionPage from "./FirstImpressionPage"
import FutureLookPage from "./FutureLookPage"
import GenderPage from "./GenderPage"
import HairstyleFrequencyPage from "./HairstyleFrequencyPage"
import PersonalityPage from "./PersonalityPage"
import PhotoUsagePage from "./PhotoUsagePage"
import ReadyToTransformPage from "./ReadyToTransformPage"
import SharePhotoPage from "./SharePhotoPage"
import StyleFeelingPage from "./StyleFeelingPage"
import StyleProfilePage from "./StyleProfilePage"
import SubscriptionCountPage from "./SubscriptionCountPage"
import TryFirstPage from "./TryFirstPage"
import TryFirstSubPage from "./TryFirstSubPage"
import UnleashLookPage from "./UnleashLookPage"

const action = navigateToNextOnboardingPageAction

const onboardingRoutes = [
  {
    path: "/onboarding",
    element: <Outlet />,
    loader: onboardingLoader,
    children: [
      {
        element: <Navigate to={`gender${window.location.search}`} replace />,
        index: true,
      },
      { action, element: <GenderPage />, path: "gender" },
      { action, element: <AgePage />, path: "age" },
      { action, element: <CompanyPage />, path: "company" },
      { action, element: <TryFirstPage />, path: "tryFirst" },
      { action, element: <UnleashLookPage />, path: "unleashLook" },
      { action, element: <FirstImpressionPage />, path: "firstImpression" },
      { action, element: <TryFirstSubPage />, path: "tryFirstSub" },
      { action, element: <StyleFeelingPage />, path: "styleFeeling" },
      {
        action,
        element: <HairstyleFrequencyPage />,
        path: "hairstyleFrequency",
      },
      { action, element: <BoldLooksPage />, path: "boldLooks" },
      { action, element: <SharePhotoPage />, path: "sharePhoto" },
      { action, element: <ExperimentingLookPage />, path: "experimentingLook" },
      { action, element: <DoingAmazingPage />, path: "doingAmazing" },
      { action, element: <ConfidenceBoostPage />, path: "confidenceBoost" },
      { action, element: <FutureLookPage />, path: "futureLook" },
      { action, element: <PersonalityPage />, path: "personality" },
      { action, element: <ComplimentPage />, path: "compliment" },
      { action, element: <StyleProfilePage />, path: "styleProfile" },
      { action, element: <ReadyToTransformPage />, path: "readyToTransform" },
      { action, element: <PhotoUsagePage />, path: "photoUsage" },
      {
        action,
        element: <SubscriptionCountPage />,
        path: "subscriptionCount",
      },
      { action, element: <AlmostTherePage />, path: "almostThere" },
    ],
  },
]

export default onboardingRoutes
